import { createSelector } from "reselect";

import { getRouteDepotStats } from "./routes";
import { getSectionDepotStats } from "./sections";

export const getDepotStatsObject = createSelector(
  getRouteDepotStats,
  getSectionDepotStats,
  (_, isRouteTab) => isRouteTab,
  (routeDepotStats, sectionDepotStats, isRouteTab) =>
    isRouteTab ? routeDepotStats : sectionDepotStats
);
